import { Link } from "react-router-dom";
import { Icon } from "./icons";
import "./legal.style.css";

const PolitiqueConfidentialite = () => (
  <div className="legal-page">
    <Link to="/" className="legal-back">
      ← Retour à l’accueil
    </Link>
    <h1>Politique de confidentialité</h1>
    <p className="legal-lead">
      La protection de vos données personnelles est importante pour nous. Cette
      politique explique quelles données nous collectons lorsque vous prenez
      rendez-vous, pourquoi, et quels sont vos droits — conformément au RGPD et à
      la loi belge du 30 juillet 2018.
    </p>
    <p className="legal-updated">
      <Icon name="calendar" /> Dernière mise à jour · septembre 2026
    </p>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="user" />
      </div>
      <div className="legal-section-body">
        <h2>1. Responsable du traitement</h2>
        <div className="legal-card">
          <p className="legal-row">
            <strong>Centre Esthétique Basilix</strong>
          </p>
          <p className="legal-row">
            Avenue Charles-Quint 420, 1082 Berchem-Sainte-Agathe (Bruxelles),
            Belgique
          </p>
          <p className="legal-row">
            Contact :{" "}
            <a href="mailto:esthetiquebasilix@gmail.com">
              esthetiquebasilix@gmail.com
            </a>{" "}
            · <a href="tel:+3223545798">+32 2 354 57 98</a>
          </p>
        </div>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="file" />
      </div>
      <div className="legal-section-body">
        <h2>2. Quelles données collectons-nous&nbsp;?</h2>
        <p>
          Lorsque vous prenez rendez-vous via notre formulaire en ligne, nous
          collectons uniquement les données suivantes :
        </p>
        <ul>
          <li>Votre nom et prénom</li>
          <li>Votre adresse e-mail</li>
          <li>Votre numéro de téléphone (GSM)</li>
          <li>Le soin/service que vous choisissez</li>
          <li>La date et l’heure du rendez-vous</li>
        </ul>
        <p>
          Nous ne collectons aucune donnée médicale ni aucune photographie via
          le site.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="check" />
      </div>
      <div className="legal-section-body">
        <h2>3. Finalités et base légale</h2>
        <p>
          Vos données sont utilisées exclusivement pour la gestion de votre
          rendez-vous : confirmation, rappel la veille et, le cas échéant,
          annulation.
        </p>
        <p>
          La base légale est l’exécution de mesures précontractuelles et
          contractuelles prises à votre demande (la prise de rendez-vous). En
          prenant rendez-vous, vous reconnaissez avoir pris connaissance de la
          présente politique.
        </p>
        <p>
          Nous n’utilisons pas vos données à des fins de marketing et ne vous
          envoyons aucune newsletter.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="share" />
      </div>
      <div className="legal-section-body">
        <h2>4. Destinataires et sous-traitants</h2>
        <p>
          Vos données ne sont accessibles qu’au personnel du centre. Pour le
          fonctionnement technique du site, nous faisons appel aux sous-traitants
          suivants :
        </p>
        <ul>
          <li>MongoDB Atlas — hébergement de la base de données</li>
          <li>Render — hébergement de l’API</li>
          <li>Netlify — hébergement du site</li>
          <li>
            Google — e-mails (Gmail), carte (Google Maps), polices (Google
            Fonts), mesure d’audience (Google Tag Manager)
          </li>
          <li>Meta (Facebook) — boutons de partage</li>
          <li>Elfsight — affichage des avis clients Google</li>
        </ul>
        <p>
          Certains prestataires sont situés hors de l’Union européenne
          (États-Unis) ; ces transferts sont encadrés par les clauses
          contractuelles types de la Commission européenne.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="clock" />
      </div>
      <div className="legal-section-body">
        <h2>5. Durée de conservation</h2>
        <p>
          Vos données de rendez-vous sont conservées pendant 3 ans à compter de
          votre dernier rendez-vous, puis supprimées.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="shield" />
      </div>
      <div className="legal-section-body">
        <h2>6. Vos droits</h2>
        <p>Conformément au RGPD, vous disposez à tout moment des droits suivants :</p>
        <ul>
          <li>Droit d’accès à vos données</li>
          <li>Droit de rectification</li>
          <li>Droit à l’effacement (« droit à l’oubli »)</li>
          <li>Droit à la limitation du traitement</li>
          <li>Droit d’opposition</li>
          <li>Droit à la portabilité de vos données</li>
        </ul>
        <p>
          Pour les exercer, contactez-nous à{" "}
          <a href="mailto:esthetiquebasilix@gmail.com">
            esthetiquebasilix@gmail.com
          </a>
          . Nous répondons dans un délai d’un mois.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="scale" />
      </div>
      <div className="legal-section-body">
        <h2>7. Réclamation</h2>
        <p>
          Si vous estimez que le traitement de vos données n’est pas conforme,
          vous pouvez introduire une réclamation auprès de l’Autorité de
          protection des données (APD) :
        </p>
        <div className="legal-card">
          <p className="legal-row">Rue de la Presse 35, 1000 Bruxelles</p>
          <p className="legal-row">
            <a href="mailto:contact@apd-gba.be">contact@apd-gba.be</a> ·{" "}
            <a
              href="https://www.autoriteprotectiondonnees.be"
              target="_blank"
              rel="noreferrer"
            >
              www.autoriteprotectiondonnees.be
            </a>
          </p>
        </div>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="cookie" />
      </div>
      <div className="legal-section-body">
        <h2>8. Cookies</h2>
        <p>
          L’utilisation des cookies sur ce site est détaillée dans notre{" "}
          <Link to="/politique-cookies">Politique de cookies</Link>.
        </p>
      </div>
    </section>
  </div>
);

export default PolitiqueConfidentialite;
